import Modal from 'react-bootstrap/Modal'
import classNames from 'classnames'
import { useState } from 'react'

import Image from '../ui/Image/Image'
import InputWithLabel from '../ui/InputWithLabel/InputWithLabel'
import { submitApi } from '../../utils/api'

import styles from './ContactFormModal.module.scss'
import close from '../../assets/images/close.svg'
import upArrow from '../../assets/images/arrowUpRight.svg'
import { phoneRegex } from '../../Contansts'
import { validateEmail } from '../../utils'

const ContactFormModal = ({
  open,
  onSubmitResponse,
  onClose,
  contactForm = [],
  button = {},
  note = '',
}) => {
  const [isClosing, setIsClosing] = useState(false)

  const [fields, setFields] = useState({
    name: { value: '', error: false },
    contactnumber: { value: '', error: false },
    email: { value: '', error: false },
    country: { value: '', error: false },
    message: { value: '', error: false },
    agreement: { value: false },
  })

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsClosing(false)
      onClose()
    }, 400)
  }

  const handleChange = (e, type) => {
    const { id, checked } = e.target || {}
    let value = e?.target?.value
    if (type === 'checkbox') {
      value = checked
    }
    if (type === 'email') {
      value = value.trim()
    }

    setFields((prevFields) => ({
      ...prevFields,
      [id]: {
        ...prevFields[id],
        value: value,
        error: false,
      },
    }))
  }

  const validateField = (item, fieldValue) => {
    const value = fieldValue.value

    switch (item?.elementid) {
      case 'contactnumber':
        return !phoneRegex.test(value)
      case 'email':
        return validateEmail(value)
      default:
        break
    }

    if (item.maxlength && value.length > item.maxlength) {
      return true
    }

    if (item.elementtype === 'checkbox' && !value) {
      return true
    }

    return false
  }

  const getFormData = (fields) => {
    return {
      name: fields?.name?.value,
      phone: fields?.contactnumber?.value.trim() || '',
      emailaddress: fields?.email?.value.trim(),
      country: fields?.country?.value || '',
      message: fields?.message?.value || '',
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()

    const updatedFields = JSON.parse(JSON.stringify(fields))
    let hasError = false

    contactForm.forEach((item) => {
      if (!item.required && !item.maxlength) return

      const field = updatedFields[item?.elementid] || {}
      let error = false
      if (item.required && field?.value === '') {
        hasError = error = true
      } else {
        error = validateField(item, field)
        if (error) hasError = true
      }
      updatedFields[item?.elementid].error = error
    })

    setFields({ ...updatedFields })

    if (!hasError) {
      // Do api call to send the data to BE
      const data = getFormData(fields)
      const result = await submitApi('contacts', data)

      if (result.data) {
        onSubmitResponse(result.data?.message || '')
      }
    }
  }

  return (
    <>
      <Modal
        show={open}
        onHide={() => onClose()}
        dialogClassName={classNames(styles['right-side-modal'], {
          [styles['slide-out']]: isClosing,
        })}
        contentClassName={classNames(styles['right-side-modal-content'])}
        backdropClassName={isClosing ? styles['slide-out'] : ''}
        animation={false}
      >
        <div
          className={classNames(
            styles['close-container'],
            'flex justify-end pb-4 md:pb-8'
          )}
        >
          <Image
            src={close}
            alt="Close"
            className={classNames(styles.closeBtn)}
            onClick={handleClose}
          />
        </div>
        {contactForm.length > 0 && (
          <form className={styles.form} onSubmit={onSubmit}>
            <div className={styles.inputsContainer}>
              {contactForm.map((element) => (
                <InputWithLabel
                  elementType={element.elementtype}
                  key={'element' + element.id}
                  label={element.label}
                  type={element.type}
                  id={element?.elementid || ''}
                  placeholder={element.placeholder}
                  required={element.required}
                  value={fields[element.elementid]?.value || ''}
                  rows={element.row}
                  maxLength={element.maxlength}
                  onChange={handleChange}
                  errorText={
                    fields[element.elementid]?.value === ''
                      ? element.emptyfielderrortext
                      : element.errorText
                  }
                  hasError={fields[element.elementid]?.error || ''}
                />
              ))}
            </div>
            <div className={styles.buttonContainer}>
              <span className={styles.formInfo}>{note}</span>
              <button
                aria-label={button.ariaLabel}
                className={classNames(styles['submit-txt'])}
                type="submit"
              >
                <span>{button.text}</span>
                <Image
                  src={upArrow}
                  alt="Arrow"
                  className={classNames(styles['action-image'])}
                />
              </button>
            </div>
          </form>
        )}
      </Modal>
    </>
  )
}

export default ContactFormModal
